/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Players_Remove_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Remove {name}?" |
*
* @param {Players_Remove_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_remove_confirm_title = /** @type {((inputs: Players_Remove_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Remove_Confirm_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Supprimer ${i?.name} ?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Eliminar a ${i?.name}?`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Remover ${i?.name}?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Rimuovere ${i?.name}?`)
	return /** @type {LocalizedString} */ (`Remove ${i?.name}?`)
});